import axios from 'axios'
import store from '../store'
import router from '../router'
import { SET_API_CALL_IN_PROGRESS } from '../store/root'

const { stringify, parse } = JSON

export const parseNetworkError = (error) => parse(stringify(error))

const HTTPClient = axios.create({
  baseURL: process.env.VUE_APP_GMOV_API_URL
})
const HTTPClientTracking = axios.create({
  baseURL: process.env.VUE_APP_GMOV_TRACKING_URL
})
const HTTPClientProtheus = axios.create({
  baseURL: process.env.VUE_APP_PROTHEUS_API_URL
})
HTTPClient.interceptors.request.use(
  (config) => {
    store.commit(SET_API_CALL_IN_PROGRESS, true)

    const token = localStorage.getItem('token')

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    return config
  },

  (error) => Promise.reject(error)
)

HTTPClient.interceptors.response.use(
  (response) => {
    store.commit(SET_API_CALL_IN_PROGRESS, false)
    return response
  },

  (error) => {
    return error.response.status === 401
      ? router.push('/login')
      : error.response
  }
)

export { HTTPClient, HTTPClientTracking, HTTPClientProtheus }
